import { Action } from '@ngrx/store';

export const VISIBLE_EDITARL = '[LAYER_E] VISIBLE';
export const HIDDEN_EDITARL = '[LAYER_E] HIDDEN';
export const UPDATE_EDITARL = '[LAYER_E] UPDATE';


export class VisiblePELAction implements Action {
  readonly type = VISIBLE_EDITARL;
  constructor() {}
}

export class HiddenPELAction implements Action {
  readonly type = HIDDEN_EDITARL;
  constructor() {}
}
export class UpdatePELAction implements Action {
  readonly type = UPDATE_EDITARL;
  constructor() {}
}

export type PELActions =
    | VisiblePELAction
    | HiddenPELAction
    | UpdatePELAction;
